import { ReactNode } from 'react';

import { Typography } from '@cast/design-system';

type Props = {
  children: ReactNode;
};

export function TourStepTitle(props: Props) {
  return (
    <Typography variant="h6" color="#fff" data-testid="title">
      {props.children}
    </Typography>
  );
}
